import React, { useState, useEffect, useContext } from "react";
import styles from "./SiderApp.module.css";
import nsIcon from "./netskope-logo-only.svg";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  NavLink,
} from "react-router-dom";
import { Affix, Col, Layout, Menu, Row, Typography } from "antd";
import {
    ClusterOutlined,
    ApartmentOutlined,
    RiseOutlined,
    CloudTwoTone,
    ApiTwoTone,
    AppstoreAddOutlined,
    HomeOutlined,
    CompassOutlined,
    ForkOutlined,
    DeploymentUnitOutlined,
    CloudServerOutlined,
} from '@ant-design/icons';
import {
    Home,
    CciTrend,
    CciApps,
    CciAppsUseCov,
    Heads,
    ConTrend,
    Applications,
    Category,
    SupActivity,
    ResearchUI,
    AppAdmin,
    SearchPage,
    TunnelMonitoring,
    GeoIp,
    TunnelGRE,
    CciGpt,
    MarketPlaceUI,
    Domain,
    MLScore,
    MCPResearchUI,
    MCPServer,
} from '../../components';
import { NAVIGATION_MENU, NAVIGATION_MENU_Link } from '../Helper/Constant';
import { UserContext } from '../Reducers/UserContext';
import { ResearchUIEditAllowRoles } from '../ResearchUI/ResearchUIConstants';
import { MLPipelineAllowRoles } from '../../common/constants';

const { Header, Sider, Content, Footer } = Layout;
const { SubMenu } = Menu;
const { Title } = Typography;

const SiderApp = (props) => {
    const [collapsed, setActiveState] = useState(false);
    const [menu, setMenu] = useState(false);
    const [hom, setHom] = useState(false);
    const [openKeys, setOpenKeys] = useState([]);
    const { isLoggedIn, setLogger } = useContext(UserContext);

    let onCollapse = () => {
        setActiveState(collapsed ? false : true);
    };

    useEffect(() => {
        setMenu(true);
        setOpenKeys(['sub1']);
        setTimeout(function () {
            setMenu(false);
        }, 50);
    }, [hom]);

    const prop = {
        ...(!collapsed && menu && { openKeys: openKeys }),
        defaultOpenKeys: ['sub1'],
        mode: 'inline',
        theme: 'dark',
        inlineIndent: 5,
    };

    const propUnsel = {
        ...(!collapsed && menu && { openKeys: openKeys }),
        defaultOpenKeys: ['sub1'],
        mode: 'inline',
        theme: 'dark',
        selectable: false,
        inlineIndent: 5,
    };

    return (
        <Layout hasSider={true} className={styles.main_layout}>
            <Sider
                className='ns-min-height-full'
                style={{
                    overflow: 'auto',
                    height: '100vh',
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    bottom: 0,
                }}
                collapsible
                collapsed={collapsed}
                onCollapse={onCollapse}
            >
                <div className={'ns-flex ns-flex_center ns-margin-top-small ' + styles.slider_header}>
                    <img src={nsIcon} alt='logo' width='40' height='30' />
                    {collapsed ? (
                        ''
                    ) : (
                        <Title level={5} className={'ns-margin-left-small ' + styles.setColor}>
                            CCI Dashboard
                        </Title>
                    )}
                </div>
                <Menu {...propUnsel}>
                    <Menu.Item key='1' onClick={() => setHom(!hom)} icon={<HomeOutlined />}>
                        <NavLink to='/'> Home</NavLink>
                    </Menu.Item>
                </Menu>
                <Menu {...prop}>
                    <SubMenu key='sub2' icon={<CloudTwoTone />} title='CCI'>
                        <Menu.Item key='2' icon={<RiseOutlined />}>
                            <NavLink to='/CciTrend'>Trend</NavLink>
                        </Menu.Item>
                        <Menu.Item key='3' icon={<AppstoreAddOutlined />}>
                            <NavLink to='/CciApps'>Applications</NavLink>
                        </Menu.Item>
                        <Menu.Item key='4' icon={<AppstoreAddOutlined />}>
                            <NavLink to='/CciAppsUseCov'>App Usage & Coverage</NavLink>
                        </Menu.Item>
                    </SubMenu>
                    <SubMenu key='sub4' icon={<ApiTwoTone />} title='Connectors' style={{ paddingBottom: '2px' }}>
                        <Menu.Item key='5' icon={<RiseOutlined />}>
                            <NavLink to='/ConTrend'>Trend</NavLink>
                        </Menu.Item>
                        <Menu.Item key='6' icon={<AppstoreAddOutlined />}>
                            <NavLink to='/Applications'>Applications</NavLink>
                        </Menu.Item>
                        <Menu.Item key='7' icon={<ApartmentOutlined />}>
                            <NavLink to='/Categories'>Categories</NavLink>
                        </Menu.Item>
                        <Menu.Item key='8' icon={<ClusterOutlined />}>
                            <NavLink to='/SupActivity'>Activities</NavLink>
                        </Menu.Item>
                    </SubMenu>
                    <Menu.Item key='9' icon={<CompassOutlined />}>
                        <NavLink to='/Geoip'>GeoIP DB</NavLink>
                    </Menu.Item>
                    <SubMenu key='tunnel' icon={<ClusterOutlined />} title={'Tunnel Monitoring'} style={{ paddingBottom: '2px' }}>
                        <Menu.Item key='10' icon={<ForkOutlined />}>
                            <NavLink to='/tunnel'>IPSec</NavLink>
                        </Menu.Item>
                        <Menu.Item key='11' icon={<DeploymentUnitOutlined />}>
                            <NavLink to='/tunnelgre'>GRE</NavLink>
                        </Menu.Item>
                    </SubMenu>
                    {isLoggedIn && MLPipelineAllowRoles?.includes(isLoggedIn['user']['role']) ? (
                        <Menu.Item key='12' icon={<CompassOutlined />}>
                            <NavLink to={NAVIGATION_MENU_Link.ML_RESEARCH_PIPELINE}>{NAVIGATION_MENU.ML_RESEARCH_PIPELINE}</NavLink>
                        </Menu.Item>
                    ) : null}
                    <Menu.Item key='13' icon={<CloudServerOutlined />}>
                        <NavLink to={NAVIGATION_MENU_Link.MCP_SERVER}>{NAVIGATION_MENU.MCP_SERVER}</NavLink>
                    </Menu.Item>
                </Menu>
            </Sider>
            <Layout className={collapsed ? styles.layout_content_body_collapsed : styles.layout_content_body}>
                <Heads />
                <Content className='bg-val'>
                    <Switch>
                        <Route path='/CciTrend' component={CciTrend} />
                        <Route path='/CciApps' component={CciApps} />
                        <Route path='/CciAppsUseCov' component={CciAppsUseCov} />
                        <Route
                            exact
                            path='/'
                            render={(props) => (
                                <Home
                                    setActiveState={setActiveState}
                                    setOpenKeys={setOpenKeys}
                                    setMenu={setMenu}
                                    isLoggedIn={isLoggedIn}
                                    hom={hom}
                                    setLogger={setLogger}
                                />
                            )}
                        />
                        <Route path='/ConTrend' component={ConTrend} />
                        <Route path='/Applications' component={Applications} />
                        <Route path='/Categories' component={Category} />
                        <Route path='/SupActivity' component={SupActivity} />
                        <Route path='/GeoIp' component={GeoIp} />
                        <Route path='/cciresearch/:id' render={(props) => <ResearchUI user={isLoggedIn['user']} />} />
                        <Route path={'/appadmin'} render={(props) => <AppAdmin user={isLoggedIn['user']} />} />
                        <Route path={'/searchpage'} render={(props) => <SearchPage />} />
                        <Route path={'/tunnel'} render={(props) => <TunnelMonitoring />} />
                        <Route path={'/tunnelgre'} render={(props) => <TunnelGRE />} />
                        {isLoggedIn && isLoggedIn['user']['role']?.includes('admin') ? (
                            <Route path={'/ccigpt'} render={() => <CciGpt />} />
                        ) : null}
                        <Route path={'/marketplace'} render={(props) => <MarketPlaceUI user={isLoggedIn['user']} />} />
                        <Route path={'/domain'} render={() => <Domain user={isLoggedIn['user']} />} />
                        {isLoggedIn && MLPipelineAllowRoles?.includes(isLoggedIn['user']['role']) ? (
                            <Route path={NAVIGATION_MENU_Link.ML_RESEARCH_PIPELINE} render={() => <MLScore />} />
                        ) : null}
                        <Route path={'/mcpserver'} render={() => <MCPServer />} />
                        <Route path={'/mcpresearch/:id'} render={() => <MCPResearchUI user={isLoggedIn['user']} />} />
                        <Route component={PageNotFound} />
                    </Switch>
                </Content>
            </Layout>
        </Layout>
    );
};

const PageNotFound = () => (
  <div className={styles.pageNF}>
    <h1>Oops! Page Not Found.</h1>
  </div>
);

export default SiderApp;
